"use strict";

exports.__esModule = true;
exports["default"] = getDisclaimersInText;
var _constants = require("../../../constants");
function getDisclaimersInText(text, disclaimers) {
  if (disclaimers === void 0) {
    disclaimers = [];
  }
  var parts = text.split(_constants.DISCLAIMER_TOKEN_GLOBAL_REGEX).filter(Boolean);
  var disclaimersInText = parts.reduce(function (out, partial) {
    var match = partial.match(_constants.DISCLAIMER_ID_REGEX);
    if (!match) {
      out.push(partial);
      return out;
    }
    var id = match[_constants.DISCLAIMER_MATCH_GROUP_INDEX];
    var _ref = disclaimers.find(function (disclaimer) {
        return disclaimer.id === id;
      }) || {},
      detail = _ref.detail;
    match[_constants.DISCLAIMER_MATCH_GROUP_INDEX] = {
      id: id,
      detail: detail
    };
    // Make sure we push all the left & right part of the text,
    // in case the `#` is in the middle, i.e.: `<p>British Columbia#1#</p>`
    // will push `Columbia`, `#1#`, `</p>`, avoiding to remove any part of the text
    out.push(match[1], match[2], match[3]);
    return out;
  }, []);
  return disclaimersInText.filter(Boolean);
}